













































































































































import { TemplatesVue } from "fs-pb-vue2/vueModels/templates/TemplatesVue";
import CatalogIcon from "@/components/catalog/CatalogIcon.vue";
import { Component, Vue } from "vue-property-decorator";
import Preloader from "@/components/app/Preloader.vue";
import i18n from "@/i18n";

@Component({
  components: { CatalogIcon, Preloader }
})
export default class ChoosenPayments extends TemplatesVue {
  sliderPos: number = 0;

  get displayedTemplates(): Array<any> {
    if (!this.simpleTemplates || !this.simpleTemplates.length) {
      return [];
    }
    
    const maxTemplates = window.innerWidth < 970 ? 8 : 16;
    return this.simpleTemplates.sort((a, b) => b.Id - a.Id).slice(0, maxTemplates);
  }

  step(flag: boolean): void {
    const length: number = this.simpleTemplates.length;
    const maxStep: number = Math.round(length / 4) + 1;
    if (flag && this.sliderPos < maxStep) {
      this.sliderPos++;
    } else if (!flag && this.sliderPos > 0) {
      this.sliderPos--;
    }
  }

  createTemplateHistory() {
    this.$router.push("/history");
    Vue.$toast.open({
      message: i18n.t("main.templates.createTemplateHistory").toString(),
      type: "info"
    });
  }
}
